import { render, staticRenderFns } from "./WFieldTextarea.vue?vue&type=template&id=471ac700&"
import script from "./WFieldTextarea.vue?vue&type=script&lang=ts&"
export * from "./WFieldTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports